import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import ActionButton from "@/components/Button/ActionButton";
import { HStack, VStack } from "@/components/Layout";
import { ProductLogoMediumContractorCore as LogoContractorCore } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { defaultNS, useTranslation } from "@/lib/i18n";

import { StartOperationTaskDialog } from "./_packages/-components/StartOperationTaskDialog";

export const Route = createFileRoute("/_staff/contractor-core/_packages")({
  component: ContractorCoreLayout,
});

function ContractorCoreLayout() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.contractorCore.operationPackages",
  });
  useDocumentTitle(t("contractorCore"));

  const [startTaskDialogOpen, setStartTaskDialogOpen] = useState(false);

  const handleCloseDialog = () => {
    setStartTaskDialogOpen(false);
  };

  const handleOpenDialog = () => {
    setStartTaskDialogOpen(true);
  };

  const tabs: TabWithIndicatorProps[] = [
    {
      to: "/contractor-core",
      children: t("tabs.operationPackages"),
      activeOptions: {
        exact: true,
      },
    },
    {
      to: "/contractor-core/archives",
      children: t("tabs.archive"),
      activeOptions: {
        exact: true,
      },
    },
    {
      to: "/contractor-core/configs",
      children: t("tabs.config"),
      activeOptions: {
        exact: true,
      },
    },
  ];

  return (
    <VStack>
      <ProductHeader
        Logo={LogoContractorCore}
        name={t("contractorCore")}
        tabs={tabs}
        type="core"
      >
        <HStack className="ml-auto items-center gap-2 pr-2">
          <ActionButton
            variant="outline"
            icon="PlusIcon"
            iconColor="primary"
            onClick={handleOpenDialog}
          >
            {t("startNew")}
          </ActionButton>
        </HStack>
      </ProductHeader>
      <Outlet />
      <StartOperationTaskDialog
        isOpen={startTaskDialogOpen}
        onClose={handleCloseDialog}
      />
    </VStack>
  );
}
